import React from 'react';
import AdminPortalHeader from '../components/AdminPortalHeader';
import AdminPortalSection from '../components/AdminPortalSection';
import type { AdminPortalProps, AdminLoginFormData } from '../types/admin';
import type { BasePortalConfig } from '../../../shared/types/portal-base';
import '../../../styles/admin-portal.css';

const AdminPortalComponent: React.FC<AdminPortalProps> = ({
  className = ''
}) => {
  const handleLogin = (formData: AdminLoginFormData) => {
    console.log('Admin login attempt:', formData);
    // Handle admin login logic here
    alert('Admin login functionality would be implemented here');
  };

  const handleResetPasswordSubmit = (email: string) => {
    console.log('Admin reset password for:', email);
    alert(`Admin reset link would be sent to: ${email}`);
  };

  const handleDownloadGuide = () => {
    console.log('Downloading admin user guide...');
    alert('Admin User Guide download would start here');
  };

  return (
    <div className={`admin-portal ${className}`}>
      <AdminPortalHeader />
      
      <div className="admin-portal-main-content">
        <div className="admin-portal-content">
          <AdminPortalSection
            config={{} as BasePortalConfig} // AdminPortalSection handles its own config internally
            onSubmit={handleLogin}
            onResetPasswordSubmit={handleResetPasswordSubmit}
            onDownloadGuide={handleDownloadGuide}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminPortalComponent;